export function assert(condition: unknown, message: string): asserts condition {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  if (!condition) throw new (Error as any)(message);
}
